import {
  getPagePath,
  trans,
  useSoyuzExperiment
} from '@spotahome/soyuz/client';

import { useInView } from 'react-intersection-observer';

import HelpCenterButton from '../FooterContainer/HelpCenterButton';

import SupportCenter from '../SupportCenter';

import FooterSimplifiedBlockTitle from './components/FooterSimplifiedBlockTitle';
import FooterSimplifiedLink from './components/FooterSimplifiedLink';

const SupportFooter = () => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1
  });

  const SupportCenterWithPhotos = useSoyuzExperiment(
    'SupportCenterWithPhotos2'
  );
  const isSupportCenterWithPhotos =
    inView && SupportCenterWithPhotos.get('behaviour') === 'variant';
  return (
    <div ref={ref}>
      <FooterSimplifiedBlockTitle text={trans('footer.label.support')} />
      {!isSupportCenterWithPhotos ? (
        <HelpCenterButton
          color="exposed"
          href={getPagePath('externals.help-center')}
        />
      ) : (
        <SupportCenter backgroundColor="white" photo="blueShort" />
      )}
      <FooterSimplifiedLink
        key="footer.item.contact_support"
        href={getPagePath('contact-us')}
      >
        {trans('footer.item.contact_support')}
      </FooterSimplifiedLink>
    </div>
  );
};

export default SupportFooter;
